module.exports = {
        srcSet: __webpack_public_path__ + "d0c89cfaefce1c46-600.webp"+" 600w"+","+__webpack_public_path__ + "c69fb7e8c568d374-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "d0c89cfaefce1c46-600.webp",width: 600,height: 600},{path: __webpack_public_path__ + "c69fb7e8c568d374-1000.webp",width: 1000,height: 1000}],
        src: __webpack_public_path__ + "c69fb7e8c568d374-1000.webp",
        toString: function(){return __webpack_public_path__ + "c69fb7e8c568d374-1000.webp"},
        
        width: 1000,
        height: 1000
      }